/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PT from 'prop-types';
import { ListPaging } from './listpaging';

export class MainPaging extends Component {
    constructor(props) {
        super(props);
    }

    handlePageChange(page) {
        this.props.onChange(page - 1);
    }

    render() {
        const pageCount = Math.ceil(this.props.itemQty / this.props.itemPerPage);

        return (
            <ListPaging
                numberOfPages={pageCount}
                currentPage={this.props.currentPage + 1} // 1 based
                onChange={this.handlePageChange.bind(this)}
                firstLabel={this.props.firstLabel}
                lastLabel={this.props.lastLabel}
                previousLabel={this.props.previousLabel}
                nextLabel={this.props.nextLabel}
            />
        );
    }
}

MainPaging.propTypes = {
    currentPage: PT.any,
    itemPerPage: PT.number,
    itemQty: PT.number,
    onChange: PT.func,
    firstLabel: PT.any,
    lastLabel: PT.any,
    previousLabel: PT.any,
    nextLabel: PT.any
};

MainPaging.defaultProps = {
    itemPerPage: 10,
    itemQty: 0,
    currentPage: 0,
    firstLastVisible: true,
    prevNextVisible: true
};
